// project import
import dashboard from './dashboard';
import utilities from './utilities';
import dmp from './dmp';
import customer from './customer';
import ControlPanel from './controlpanel';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [customer,ControlPanel,dashboard, dmp, utilities]
};

export default menuItems;